module.exports = __webpack_public_path__ + "static/media/upload2.c780404b.png";